import { Component, Inject, Input, inject } from '@angular/core';
import { Diary, IDiary } from '../../../models/diary';
import { Store } from '@ngxs/store';
import { CardModule } from 'primeng/card';
import { AsyncPipe, DatePipe, NgFor, NgIf, SlicePipe } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/dialog';
import { DiaryEditorComponent } from '../diary-editor/diary-editor.component';
import { TableModule } from 'primeng/table';
import { UserHeader } from '../../../models/user';
import { UserService } from '../../../services/user.service';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IDiaryHandler } from './diary-handler';
import { TooltipModule } from 'primeng/tooltip';
import { SYSTEM_USER_ID } from '../../../services/injection-tokens';

@Component({
  selector: 'app-diary-list',
  standalone: true,
  imports: [CardModule, SlicePipe, NgIf, NgFor,PanelModule, TagModule,DividerModule, DatePipe, ButtonModule,
         OverlayPanelModule, DiaryEditorComponent,TableModule, AsyncPipe,
         DropdownModule,CalendarModule, FormsModule,FloatLabelModule, DialogModule, TooltipModule],
  templateUrl: './diary-list.component.html',
  styleUrl: './diary-list.component.scss'
})
export class DiaryListComponent
{
  @Input() diaries: Diary[] = [];
  @Input() handler: IDiaryHandler | undefined = undefined;


  now = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  showClosed: boolean = false;
  viewDiary: Diary | undefined = undefined;
  viewDiaryBody: string = '';
  viewDiaryVisible: boolean = false;

  protected _store:Store = inject(Store); 
  protected _user:UserService = inject(UserService)

  activeUsers$: Promise<UserHeader[]> = this._user.getActiveUsers();


  expandedDiaries: boolean[] = [];

  get sortedDiaries() : Diary[]
  {
    // deprioritize the close diaries
    var closedDiaries = this.showClosed ? this.diaries.filter(d => d.closedDate) : [];
    var openDiaries = this.showClosed ? [] : this.diaries.filter(d => d.closedDate == null);

    openDiaries.sort((a, b) => (a.dueDate?.valueOf() ?? a.createdDate.valueOf()) - (b.dueDate?.valueOf() ?? b.createdDate.valueOf()));
    closedDiaries.sort((a, b) => (b.closedDate?.valueOf() ?? b.dueDate!.valueOf()) - (a.closedDate?.valueOf() ?? a.dueDate!.valueOf()));
    return [...openDiaries, ...closedDiaries];
  }

  set sortedDiaries(val: Diary[])
  {
    this.diaries = val
  }

  constructor(@Inject(SYSTEM_USER_ID) protected systemUserId: number)
  {
  }

  async addDiary(diary: IDiary)
  {
    var addedDiary = await this.handler?.addDiary(diary)
  }
  closeDiary(diary: Diary)
  {
    this.handler?.closeDiary(diary)
  }
  assignDiary(diary: Diary, user: UserHeader, dueDate: Date)
  {
    this.handler?.assignDiary(diary,user,dueDate)
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  isDueToday(dueDate: Date | null): boolean {
    if (!dueDate) return false;
    return this.isSameDay(new Date(dueDate), this.now);
  }

}